import * as React from 'react'
import { createContext, FC, PropsWithChildren } from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import { IMenuData, IMenuResponse } from '../../../models/Menu'
import { locale } from '../../../state/locale/atoms/locale'

const initialState: IMenuData = {
  navItems: [],
}

export const MenuContext = createContext(initialState)

export const MenuContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const lang = useRecoilValue(locale)
  const { data } = useSWR<IMenuResponse>(URI.getMenuUri(lang))

  if (!data?.data) return <>{children}</>

  return <MenuContext.Provider value={data.data} children={children} />
}
